export default __webpack_public_path__ + "static/media/taylor-wright-s8Yz0dqKrVI-unsplash_edited.68de350a.webp";